//测试环境
const upload_url = 'https://ytk.yitku.com/api/uploads';
const admin_api = 'https://ytk.yitku.com/api';
// const admin_api = 'https://qinc-api.xiaocx.tech/Admin';
export default {
  bytesToMBDecimal(bytes, decimal = 2) {
    if (typeof bytes !== 'number' || isNaN(bytes) || bytes < 0) {
      return '0.00 MB';
    }
    const mb = bytes / (1000 ** 2);
    return mb.toFixed(decimal) + ' MB';
  },
  secToMin(seconds) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    const hh = String(h).padStart(2, '0');
    const mm = String(m).padStart(2, '0');
    const ss = String(s).padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
  },
  // 计算百分比，保留指定位数小数
  getPercent(part, total, fixed = 2) {
    if (total === 0) return '0%'
    return ((part / total) * 100).toFixed(fixed)
  },
  upload_url,
  admin_api,
}
